/*
 *  Landing Countdown Timer
 *    Scripts for the countdown timer used on landing pages.
 *
 *
 *  Version:
 *    1.0.0 - 2019/05/13
 */

import $ from 'jquery';
import { register, ShopifySection } from './../ShopifySection';
import { liquidToDate } from '@process-creative/slate-theme-tools';

export const CONTAINER_SELECTOR = '[data-sale-promobar]';
export const COUNTER_ROW = '[data-counter-row]';

export const TIME_ATTR = 'data-sale-promo-end';
export const OFFSET_TO_MS = 60000;
export const STATIC_TIMEZONE = -600; //Offset that the end date will be set in.

export class SalePromobar extends ShopifySection {
  constructor(container) {
    super(container);
    this.container = container;

    this.counterRow = container.find(COUNTER_ROW);

    // this.end = new Date(`${this.container.attr(TIME_ATTR)}`);
    this.end = liquidToDate(`${this.container.attr(TIME_ATTR)}`);
    this.targetTimezone = STATIC_TIMEZONE * OFFSET_TO_MS;

    //Start Timer
    setInterval(() => this.tick(), 200);
  }

  tick() {

    let now = new Date();//System Time
    let myTimezone = now.getTimezoneOffset() * OFFSET_TO_MS;
    let diff = ((now.getTime()+myTimezone) - (this.end.getTime()+this.targetTimezone));
    if(diff >= 0) return; // Time remaining should be negative, return if not
    diff = Math.abs(diff); // We've got time remaining, but we need abs value

    let days = Math.floor(diff / (1000 * 60 * 60 * 24));
    let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((diff % (1000 * 60)) / 1000);

    let p = n => `${n}`.padStart(2, '0');

    let print = `<td>${p(days)}</td><td>:</td><td>${p(hours)}</td><td>:</td><td>${p(minutes)}</td><td>:</td><td>${p(seconds)}</td>`;
    this.counterRow.html(print);
  }

}

register(CONTAINER_SELECTOR, SalePromobar);
